<template>
  <div>
    <div @mouseleave="drawerRight = false">
      <v-navigation-drawer
        v-model="drawerRight"
        app
        hide-overlay
        fixed
        clipped
        color="nav"
        id="keep"
        right
      >
        <v-card class="elevation-0 mb-5 mt-5 text-center" color="nav">
          <div>{{ locale[local].screen.navDrawerRight.wellcome }},</div>
          <div>
            <strong>{{ nomeUsuarioLogado }}</strong>
          </div>
        </v-card>
        <v-divider></v-divider>

        <v-list class="text-left" nav dense mandatory>
          <v-list-group
            active-class="primary"
            color="white"
            prepend-icon="mdi-account"
            :value="false"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ locale[local].screen.navDrawerRight.user }}</v-list-item-title>
            </template>
            <v-list-group
              active-class="primary"
              color="white"
              sub-group
              :value="false"
              prepend-icon="mdi-exit-to-app"
              @click="logOut"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ locale[local].screen.navDrawerRight.btnLogout }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-group>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>
    </div>

    <v-app-bar fixed clipped-left clipped-right color="primary" dark app>
      <v-app-bar-nav-icon>
        <v-img
          height="30"
          :src="`logo-pequeno.png`"
          :lazy-src="`logo-pequeno.png`"
          contain
          @click="goHome"
        >
          <template v-slot:placeholder>
            <v-layout fill-height align-center justify-center ma-0>
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
      </v-app-bar-nav-icon>
      <v-toolbar-title>{{ this.$appName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn text @click="drawerRight = !drawerRight">
          <v-icon left>mdi-account</v-icon> {{ nomeUsuarioLogado }}
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
import LoginVue from "@/views/Login";
export default {
  data() {
    return {
      nomeUsuarioLogado: null,
      drawerRight: false
    };
  },
  created() {
    this.nomeUsuarioLogado = localStorage.getItem("nomePessoa");
  },
  methods: {
    goHome() {
      // eslint-disable-next-line no-unused-vars
      this.$router.push("home").catch(err => {
        window.location.reload();
      });
    },
    logOut() {
      localStorage.removeItem("codPessoa");
      sessionStorage.removeItem("logado")
      this.$emit("home", LoginVue);
      this.goHome();
      this.$emit("login", LoginVue);
    }
  }
};
</script>
